module.exports = __webpack_public_path__ + "static/media/col2row1.0ddb8963.jpg";